module.exports = __webpack_public_path__ + "amcharts/images/dragIconRoundSmallBlackH.png";


//////////////////
// WEBPACK FOOTER
// ./~/file-loader?name=amcharts/images/[name].[ext]!./~/amstock3/amcharts/images/dragIconRoundSmallBlackH.png
// module id = 258
// module chunks = 0